import { render, staticRenderFns } from "./SimObjectDetails.vue?vue&type=template&id=72242a45&scoped=true"
import script from "./SimObjectDetails.vue?vue&type=script&lang=js"
export * from "./SimObjectDetails.vue?vue&type=script&lang=js"
import style0 from "./SimObjectDetails.vue?vue&type=style&index=0&id=72242a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72242a45",
  null
  
)

export default component.exports